import axios from "axios";

export const NotificationsService = {
  unreadCount: async () => axios.get('admin/notification/unread').then(res => res?.data),
  list: async (unread) => axios.get(`admin/notification/${unread !== undefined ? `?unread=${unread}` : ''}`).then(res => res?.data),
}